import api from "./api";
import log from "../utils/logger";
import axios from "axios";

export const queryDocument = async ({
  documentExcerpt,
  query,
  promptConfigId,
  wholeDocument,
  abortSignal,
}: {
  documentExcerpt: string;
  query: string;
  promptConfigId: string;
  wholeDocument: string;
  abortSignal?: AbortSignal;
}) => {
  try {
    const response = await api.post<{ body: string; statusCode: number }>(
      "/chat/ask",
      {
        promptConfigId,
        documentExcerpt,
        query,
        wholeDocument,
      },
      {
        signal: abortSignal,
      }
    );
    return response.data.body;
  } catch (error) {
    if (axios.isCancel(error)) {
      log.info("Document query was cancelled");
      throw new Error("Request was cancelled");
    }
    log.error("Document query error:", undefined, error);
    throw error;
  }
};

export const draftNewClause = async ({
  promptConfigId,
  wholeDocument,
  clauseDescription,
  abortSignal,
}: {
  wholeDocument: string;
  clauseDescription: string;
  promptConfigId: string;
  abortSignal?: AbortSignal;
}) => {
  try {
    const response = await api.post<{ body: string; statusCode: number }>(
      "/chat/draft/new-clause",
      {
        promptConfigId,
        wholeDocument,
        clauseDescription,
      },
      {
        signal: abortSignal,
      }
    );
    return response.data.body;
  } catch (error) {
    if (axios.isCancel(error)) {
      log.info("Draft new clause was cancelled");
      throw new Error("Request was cancelled");
    }
    log.error("Draft new clause error:", undefined, error);
    throw error;
  }
};

export const rewriteSelectedText = async ({
  promptConfigId,
  rewritingDescription,
  selectedText,
  abortSignal,
}: {
  selectedText: string;
  rewritingDescription: string;
  promptConfigId: string;
  abortSignal?: AbortSignal;
}) => {
  try {
    const response = await api.post<{ body: string; statusCode: number }>(
      "/chat/draft/rewrite-text",
      {
        promptConfigId,
        rewritingDescription,
        selectedText,
      },
      {
        signal: abortSignal,
      }
    );
    return response.data.body;
  } catch (error) {
    if (axios.isCancel(error)) {
      log.info("Rewrite text was cancelled");
      throw new Error("Request was cancelled");
    }
    log.error("Rewrite text error:", undefined, error);
    throw error;
  }
};
